import React from 'react'
import { Navigate } from 'react-router-dom'

const AdminProtection = ({ children }) => {
    
    const user = localStorage.getItem('userRole');
    console.log(user);
    if (user === 'admin') {
        return children
    } else {
        return <Navigate to="/" />
    }
}
export default AdminProtection